// 注意：必须先赋给具名变量再 default export。
// 若写成 `export default { ... }` 匿名字面量，babel 编译产物是无源码位置的合成节点，
// istanbul 无法插桩，覆盖率恒为 0%。
const errorCode = {
  NOT_FOUND: 404,
  NOT_EXISTENT: 10021,
  UNAUTHORIZED: 401,
  UNBIND_PHONE: 10001,
  NO_PERMISSION_EDIT: 10002,
  UPLOAD_WAF_INTERCEPT: 405,
};

export default errorCode;
